import { render, staticRenderFns } from "./group.vue?vue&type=template&id=2f22760e&"
import script from "./group.js?vue&type=script&lang=js&"
export * from "./group.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports